import script from "./AppLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLoader.vue?vue&type=script&setup=true&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=0f4a4519&lang=css"

const __exports__ = script;

export default __exports__
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerIos});
